export const enUS = {
  // Hero Section
  hero: {
    jobTitle: "Software Engineer & Computer Engineer",
    name: "Renan Ferreira",
    subtitle: "Full-stack software engineer",
    contactButton: "Contact Me",
    linkedinButton: "LinkedIn"
  },

  // Navigation
  nav: {
    about: "About",
    experience: "Experience",
    skills: "Skills",
    education: "Education",
    contact: "Contact"
  },

  // About Section
  about: {
    title: "About Me",
    description:
      "Computer Engineer graduated from the Federal University of Santa Catarina and founder of Remi, a fitness and social wellness app I design, build, and ship end to end — from the React Native product to the Node.js backend behind it. Alongside Remi, I work as a fullstack software engineer building scalable and reliable frontend and backend systems, with contributions that improved performance, security, and user experience across multiple products. Passionate about continuous learning, I actively expand my skill set with new languages, tech stacks, and architectural patterns",
    expertiseTitle: "Areas of Expertise",
    location: "Curitiba, Paraná, Brazil",
    email: "renanferreira.engineer@gmail.com",
    software: "Software",
    facts: {
      title: "At a glance",
      currently: "Currently",
      founder: "Founder",
      education: "Education",
      basedIn: "Based in",
      email: "Email"
    },
    remi: {
      badge: "Founder",
      name: "Remi",
      tagline: "Fitness & social wellness app",
      description:
        "A cross-platform mobile app for tracking workouts and GPS activities, competing in quest-based challenges, and connecting with a community of fitness enthusiasts — designed, built, and shipped end to end.",
      stack: ["React Native", "Expo", "Node.js", "PostgreSQL"],
      cta: "See the project",
      website: "remifitness.com"
    },
  },

  // Experience Section
  experience: {
    visitSite: "Visit site",
    professionalTitle: "Professional Experience",
    founderTitle: "Founder",
    researchTitle: "Research Experience",
    rise: {
      company: "Rise",
      role: "Software Engineer",
      period: "Present",
      location: "New York, NY",
      description:
        "Rise is a platform that simplifies global payroll for modern teams, enabling streamlined payments to both contractors and full-time employees worldwide. Full-stack software engineer developing scalable solutions for international payroll processing and compliance.",
      highlights: []
    },
    voyager: {
      company: "Voyager",
      role: "Software Engineer",
      period: "Nov 2022 - Dec 2024",
      location: "Houston, TX",
      description:
        "Voyager is a maritime logistics solution. Working in the demurrage team, developing solutions to automate demurrage calculations. Full-stack software engineer working with Vue.js, Node.js, Python, MySQL, Gitlab and AWS services.",
      highlights: [
        "Led development of a system interpreting ship events from Statements of Facts (SOF) for automated demurrage calculations",
        "Spearheaded development of a tool for analyzing demurrage calculations and collaboration called negotiation cockpit",
        "Built first version of a low-code platform for maritime contract registration",
        "Contributed to bug fixes and developed reusable UI components across projects"
      ]
    },
    medprev: {
      company: "MedPrev",
      role: "Software Engineer",
      period: "Feb 2022 - Nov 2022",
      location: "Curitiba, PR",
      description:
        "Part of the team facilitating medical appointments and exams scheduling. Full-stack software engineer working with Vue.js, Node.js, Python, PostgreSQL and Azure services.",
      highlights: [
        "Led development of an assisted purchase system for exams/appointments",
        "Built first version of a user experience evaluation system",
        "Maintained core scheduling system components"
      ]
    },
    cargon: {
      company: "Cargon",
      role: "Software Engineer",
      period: "Mar 2020 - Feb 2022",
      location: "Curitiba, PR",
      description:
        "Worked on document issuing system for delivery drivers. Full-stack software engineer using Node.js, React.js, MicrosoftSQLServer and Azure services.",
      highlights: [
        "Contributed to first version of issuing system, responsible for core components",
        "Led development of complementary CTE issuing system"
      ]
    },
    remi: {
      company: "Remi",
      url: "https://remifitness.com",
      role: "Founder & Full-stack Engineer",
      period: "Present",
      location: "Curitiba, PR",
      description:
        "Remi is a fitness and social wellness mobile app that helps users track workouts, create training routines, compete in fitness quests, and connect with other fitness enthusiasts.",
      highlights: [
        "Built a cross-platform mobile app with React Native and Expo, with a Node.js/Express backend and PostgreSQL database",
        "Developed real-time GPS activity tracking for runs, rides, and hikes with interactive map visualization",
        "Implemented social features including feed, real-time messaging, communities, and team challenges",
        "Integrated gamification with quest-based workouts, achievements, and XP progression system",
        "Set up subscription and e-commerce system"
      ]
    },
    automation: {
      company: "Automation and Mobile Robotics Laboratory",
      role: "Researcher",
      period: "Apr 2018 – Dec 2018",
      location: "UFSC",
      description:
        "Used ESP8266 microprocessor and RFID to automate attendance registration."
    },
    quantumTeam: {
      company: "Quantum Team",
      role: "Microprocessor Programmer",
      period: "Jul 2018 – Apr 2020",
      location: "UFSC",
      description:
        "Programmed robots using Arduino and ESP8266 for regional/national competitions."
    },
    plusEnergy: {
      company: "Plus Energy",
      role: "Web System Developer",
      period: "Jul 2019 – Apr 2020",
      location: "UFSC",
      description:
        "Developed communication system between wind tower and control center, including web interface for data analysis."
    }
  },

  // Skills Section
  skills: {
    title: "Skills",
    hardSkills: "Hard Skills",
    softSkills: "Soft Skills",
    projectTools: "Project Management & Tools"
  },

  // Education Section
  education: {
    title: "Education",
    degree: "Computer Engineering",
    university: "Federal University of Santa Catarina",
    period: "2018-2022",
    location: "Araranguá, SC",
    highlights: "Program Highlights",
    description:
      "Comprehensive curriculum covering both hardware and software aspects of computer engineering, with a focus on practical applications and cutting-edge technologies.",
    coursework: "Relevant Coursework:",
    courses: [
      "Computer Architecture",
      "Algorithms and Data Structures",
      "Embedded Systems",
      "Database Systems",
      "Web Development",
      "IoT Technologies",
      "Digital Signal Processing",
      "Operating Systems"
    ],
    researchProjects: "Research Projects",
    projects: [
      "Automated attendance system using RFID technology",
      "IoT-based environmental monitoring systems"
    ]
  },

  // Contact Section
  contact: {
    title: "Get In Touch",
    description:
      "I'm always open to discussing new projects, creative ideas or opportunities to be part of your vision. Let's connect!",
    email: "Email",
    linkedin: "LinkedIn",
    location: "Location",
    connect: "Connect with me",
    github: "GitHub"
  },

  // Footer
  footer: {
    jobTitle: "Software Engineer",
    copyright: "All rights reserved."
  },

  // Language Switcher
  langSwitcher: {
    switchTo: "Mudar para Português"
  }
};
